<po-page-list #pageListComponent [p-breadcrumb]="breadcrumb" p-title="Salas"
  [p-disclaimer-group]="disclaimerGroup" [p-actions]="pageActions" [p-filter]="filterSettings"
  p-subtitle="Consulte os dados cadastrados no sistema.">

  <div class="sl-summary">
    <div class="sl-summary-icon">
      <i class="an an-door-open"></i>
    </div>
    <div class="sl-summary-text">
      <span class="sl-summary-title">Salas cadastradas</span>
      <span class="sl-summary-hint">Gerencie as salas e os horários de acesso dos usuários.</span>
    </div>
  </div>

  <po-divider></po-divider>

  <div class="sl-table-wrapper po-mt-2">
    <po-loading-overlay [hidden]="isHideLoading"></po-loading-overlay>
    <po-table #dynamicTable p-container="border" [p-actions]="actions" class="po-lg-12" #wppTable
      (p-show-more)="loadMore()" [p-show-more-disabled]="!moreItens" p-striped="true" p-text-wrap="true"
      [p-spacing]="poTableColumnSpacing" [p-loading-show-more]="!isHideLoading" p-container="border"
      p-hide-columns-manager="false" [p-columns]="columns" [p-items]="items">
    </po-table>
  </div>
</po-page-list>

  <po-modal #modalEditUsers class="modal-editar-usuarios" p-size="xl" [p-title]="modalEditUsersTitle" p-icon="po-icon po-icon-users"
    p-click-out="false">

    <div class="po-row po-mb-3" style="display: flex; align-items: flex-start; justify-content: space-between;">
      <div>
        <p class="po-font-subtitle po-mb-0">Usuários com acesso a esta sala</p>
      </div>
      <div class="filter-add-container" style="display: flex; align-items: center; gap: 8px; margin-left: auto;">

        <po-button class="add-user-button" p-label="+ Add Usuário" p-kind="primary" (p-click)="addUser()"></po-button>
        <po-input #userFilterInput class="filter-input" style="min-width: 200px; margin-left: auto;" p-placeholder="Pesquisar usuário..."
          [(ngModel)]="userFilterText" (p-enter)="onFilterUserChange($event)" (p-blur)="onFilterUserBlur()"
          (input)="onFilterUserInput($event)" p-icon="po-icon po-icon-search" p-clean="true">
        </po-input>
      </div>
      <po-button p-label="Copiar registro de outra sala" p-kind="secondary" (p-click)="openCopyFromRoomModal()"
      icon="po-icon po-icon-copy"></po-button>
    </div>

    <po-divider></po-divider>
    <br>

      <div class="po-row">
        <div class="table-container-wrapper">
          <div>
            <po-loading-overlay [hidden]="isHideLoadingUsers"></po-loading-overlay>
          </div>
          <po-table p-container="border" class="po-lg-12" p-striped="true" p-text-wrap="true"
            [p-columns]="usersTableColumns" [p-items]="roomUsersFiltered" p-hide-columns-manager="true"
            [p-selectable]="true" [p-single-select]="true" [p-selectable-entire-line]="true"
            (p-selected)="selecionaUsuario($event)"
            (p-show-more)="loadMoreRoomUsers()" [p-show-more-disabled]="!roomUsersHasMore"
            [p-loading-show-more]="!isHideLoadingUsers">
            <ng-template p-table-cell-template let-column="column" let-row="row">
              @if (column.property === 'actions') {
                <div style="text-align: right;" (click)="$event.stopPropagation()">
                  <i class="an-fill an-x-circle" style="color: #c64840; cursor: pointer; font-size: 1.2em;"
                  (click)="$event.stopPropagation(); removeUserAccess(row)" title="Remover acesso"></i>
                </div>
              }
            </ng-template>
          </po-table>
        </div>
      </div>

      <po-modal-footer>
        <po-button p-label="Fechar" p-kind="primary" (p-click)="modalEditUsers.close()"></po-button>
      </po-modal-footer>
    </po-modal>

    <!-- Modal Copiar registro de outra sala -->
    <po-modal #modalCopyFromRoom class="modal-copy-from-room" p-size="lg" [p-title]="modalCopyFromRoomTitle"
      p-icon="po-icon po-icon-copy" p-click-out="false">
      <div style="position: relative;">
        <po-loading-overlay [hidden]="!replicatingAccess"></po-loading-overlay>
        <div class="po-row po-mb-3">
          <p class="po-font-text po-mb-2">Selecione a sala de origem da qual deseja copiar os usuários e horários de acesso. Os registros atuais desta sala serão substituídos.</p>
        </div>
        <div class="po-row">
          <div class="table-container-wrapper" style="width: 100%;">
            <div>
              <po-loading-overlay [hidden]="isHideLoadingCopyRooms"></po-loading-overlay>
            </div>
            <po-table p-container="border" class="po-lg-12" p-striped="true" p-text-wrap="true"
              [p-columns]="copyFromRoomTableColumns" [p-items]="copyFromRoomList"
              [p-selectable]="true" [p-single-select]="true" [p-selectable-entire-line]="true"
              (p-selected)="onCopySourceRoomSelected($event)"
              p-hide-columns-manager="true">
            </po-table>
            @if (copyFromRoomList.length === 0 && isHideLoadingCopyRooms) {
              <div class="sl-empty-state">
                <i class="an an-magnifying-glass"></i>
                <p>Nenhuma outra sala disponível para cópia.</p>
              </div>
            }
          </div>
        </div>
      </div>
      <po-modal-footer>
        <po-button p-label="Cancelar" (p-click)="modalCopyFromRoom.close()" [p-disabled]="replicatingAccess"></po-button>
        <po-button p-label="Confirmar cópia" p-kind="primary" [p-disabled]="!selectedSourceRoomForCopy || replicatingAccess"
        [p-loading]="replicatingAccess" (p-click)="confirmCopyFromRoom()"></po-button>
      </po-modal-footer>
    </po-modal>

    <!-- Modal Editar horário - menor que o anterior (metade da largura, menor altura) -->
    <po-modal #modalAddUser class="modal-editar-horario" [p-title]="modalEditarHorarioTitle" p-icon="po-icon po-icon-clock"
      p-click-out="false">
      <div class="modal-editar-horario-content">
        <div class="po-row add-user-modal-row">
          <div class="po-sm-12 add-user-modal-label">
            @if (!addingHorarioForUser) {
              <p class="po-font-text po-mb-2">Defina o usuário que terá acesso a esta sala:</p>
            }
            @if (addingHorarioForUser && editingScheduleIndex === null) {
              <p class="po-font-text po-mb-2">Insira o novo horário de acesso para {{ addingHorarioForUser?.name || addingHorarioForUser?.tag || 'usuário' }} nesta sala</p>
            }
            @if (addingHorarioForUser && editingScheduleIndex !== null) {
              <p class="po-font-text po-mb-2">Edite o horário de acesso para {{ addingHorarioForUser?.name || addingHorarioForUser?.tag || 'usuário' }} nesta sala</p>
            }
          </div>
          @if (!addingHorarioForUser) {
            <div class="po-sm-12">
              <po-combo p-placeholder="Selecione um usuário..."
                [p-options]="usersToAddOptions" p-name="userToAdd" p-clean="true"
                (p-change)="onUserToAddChange($event)">
              </po-combo>
            </div>
          }
        </div>
        <div class="po-row add-user-modal-section add-user-modal-two-cols">
          <div class="po-sm-12 po-md-6 modal-horario-col-left">
            <po-checkbox-group p-label="Dias da semana" [p-options]="diasSemanaComAtivoOptions"
              [ngModel]="diasSemanaComAtivoSelecionados" (ngModelChange)="onDiasSemanaComAtivoChange($event)"
              name="diasSemanaComAtivo" [p-columns]="2">
            </po-checkbox-group>
          </div>
          <div class="po-sm-12 po-md-6 modal-horario-col-right">
            <po-input p-label="Hora de início" p-placeholder="HH:mm" name="horaInicio"
              [(ngModel)]="horaInicio">
            </po-input>
            <po-input p-label="Hora de término" p-placeholder="HH:mm" name="horaTermino"
              [(ngModel)]="horaTermino">
            </po-input>
          </div>
        </div>
        @if (modalEditarHorarioError) {
          <div class="po-row po-pt-2">
            <p class="po-font-text" style="color: #c64840; margin: 0;">{{ modalEditarHorarioError }}</p>
          </div>
        }
      </div>
      <po-modal-footer>
        <po-button p-label="Cancelar" (p-click)="closeAddUserModal()"></po-button>
        <po-button p-label="Salvar" p-kind="primary" [p-disabled]="savingAddUser" (p-click)="confirmAddUser()"></po-button>
      </po-modal-footer>
    </po-modal>

    <!-- Modal Horários - exibido ao clicar na linha do usuário -->
    <po-modal #modalHorarios class="modal-horarios" p-size="xl" [p-title]="modalHorariosTitle" p-icon="po-icon po-icon-clock"
      p-click-out="false">
      <div class="modal-horarios-content">
        @if (selectedUserForHorarios) {
          <p class="po-font-subtitle po-mb-2">
            Horários de acesso: {{ selectedUserForHorarios.name || selectedUserForHorarios.tag || 'Usuário' }}
          </p>
        }
        <po-divider></po-divider>
        <br>
          <div class="po-row po-mb-3 modal-horarios-toolbar" style="display: flex; align-items: flex-start; justify-content: space-between;">
            <p class="po-font-text po-mb-0">Clique na linha desejada para editar o horário de entrada e saída</p>
            <po-button p-label="Add Horário" p-kind="primary" (p-click)="addHorario()"></po-button>
          </div>
          <div class="table-container-wrapper">
            <po-table p-container="border" class="po-lg-12" p-striped="true" p-text-wrap="true"
              [p-columns]="scheduleTableColumns" [p-items]="scheduleTableItems" p-hide-columns-manager="true"
              [p-selectable]="true" [p-single-select]="true" [p-selectable-entire-line]="true"
              (p-selected)="onScheduleRowSelected($event)">
              <ng-template p-table-cell-template let-column="column" let-row="row">
                @if (column.property === 'actions') {
                  <div style="text-align: right;" (click)="$event.stopPropagation()">
                    <i class="an-fill an-x-circle" style="color: #c64840; cursor: pointer; font-size: 1.2em;"
                    (click)="$event.stopPropagation(); removeScheduleItem(row)" title="Excluir horário"></i>
                  </div>
                }
              </ng-template>
            </po-table>
          </div>
        </div>
        <po-modal-footer>
          <po-button p-label="Fechar" p-kind="primary" (p-click)="closeHorariosModal()"></po-button>
        </po-modal-footer>
      </po-modal>

      <!-- Modal Registro de Acesso -->
      <po-modal #modalAccessLogs class="modal-access-logs" p-size="xl" [p-title]="modalAccessLogsTitle" p-icon="po-icon po-icon-list"
        p-click-out="false">
        <div class="modal-access-logs-content">
          <div class="po-row po-mb-3" style="display: flex; align-items: flex-start; justify-content: space-between; gap: 16px;">
            <po-datepicker-range
              class="po-lg-4"
              p-label="Filtrar por período"
              p-name="accessLogDateRange"
              [(ngModel)]="accessLogDateRange"
              (p-change)="onAccessLogDateRangeChange()"
              (p-clean)="clearAccessLogDateFilter()"
              p-placeholder-start="Data inicial"
              p-placeholder-end="Data final"
              [p-clean]="true"
              p-help="Selecione o período para filtrar os registros de acesso">
            </po-datepicker-range>
            <po-input
              class="po-lg-4"
              style="margin-left: auto;"
              p-label="Pesquisar"
              p-placeholder="Pesquisar por tag ou usuário..."
              [(ngModel)]="accessLogsSearchText"
              (p-enter)="onAccessLogsSearchChange()"
              (input)="onAccessLogsSearchInput($event)"
              (p-blur)="onAccessLogsSearchBlur()"
              p-icon="po-icon po-icon-search"
              p-clean="true">
            </po-input>
          </div>

          <div class="po-row">
            <div class="table-container-wrapper access-logs-wrapper" style="width: 100%;">
              <div>
                <po-loading-overlay [hidden]="isHideLoadingAccessLogs"></po-loading-overlay>
              </div>
              @if (accessLogs.length > 0) {
                <po-table p-container="border" class="po-lg-12" p-striped="true" p-text-wrap="true"
                  [p-columns]="accessLogsTableColumns" [p-items]="accessLogs" p-hide-columns-manager="true"
                  (p-show-more)="loadMoreAccessLogs()" [p-show-more-disabled]="!accessLogsHasMore"
                  [p-loading-show-more]="!isHideLoadingAccessLogs">
                  <ng-template p-table-cell-template let-column="column" let-row="row">
                    <div *ngIf="column.property === 'actions'" style="display: flex; justify-content: flex-start; align-items: center; padding-left: 0;">
                      <i
                        class="an an-eye"
                        style="color: #0c9abe; cursor: pointer; font-size: 1.2em; margin-left: -8px;"
                        (click)="showAccessReason(row)"
                        title="Ver motivo do acesso">
                      </i>
                    </div>
                  </ng-template>
                </po-table>
              }
              @if (accessLogs.length === 0 && isHideLoadingAccessLogs) {
                <div class="sl-empty-state">
                  <i class="an an-magnifying-glass"></i>
                  <p>Nenhum registro de acesso encontrado</p>
                </div>
              }
            </div>
          </div>
        </div>
        <po-modal-footer>
          <po-button p-label="Fechar" p-kind="primary" (p-click)="modalAccessLogs.close()"></po-button>
        </po-modal-footer>
      </po-modal>

